import { render, staticRenderFns } from "./DisableConfirmation.vue?vue&type=template&id=c30d2028"
import script from "./DisableConfirmation.vue?vue&type=script&lang=js"
export * from "./DisableConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports